import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/index.css';
import { HelmetProvider } from 'react-helmet-async';
import { initSentry } from './config/sentry';
import './tracing.ts';

initSentry();
ReactDOM.createRoot(document.getElementById('root')!).render(
   <React.StrictMode>
      <HelmetProvider>
         <App />
      </HelmetProvider>
   </React.StrictMode>,
);
